module.exports = "../static/images/c709ad.gif";